import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import StepOne from './StepOne';
import Result from './Result';
import StepTwo from './StepTwo';
import {
  diagnoseDisease,
  resetState,
  setActiveState,
} from '../redux/selfDiagnosisActions';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useStyles = makeStyles((theme) => ({
  paper: {
    minWidth: 550,
    padding: 0,
  },
  root: {
    padding: 30,
  },
  button: {
    marginRight: theme.spacing(1),
    color: 'white',
    background: '#00b074',
    '&:hover': {
      background: '#019563',
    },
  },
  backbutton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {icons[String(props.icon)]}
    </div>
  );
}
function getSteps() {
  return ['Please select your symptoms', 'Select one more symptom', 'Results'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'Please select your symptoms';
    case 1:
      return 'Select one more symptom';
    case 2:
      return 'Results';
    default:
      return 'Unknown step';
  }
}

function DiagnoiseWizard({ open, onClose }) {
  const classes = useStyles();
  // const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const dispatch = useDispatch();

  const activeState = useSelector(
    (state) => state.selfDiagnosisReducer.activeState
  );
  const result = useSelector((state) => state.selfDiagnosisReducer.result);
  const handleNext = () => {
    if (activeState === 0) {
      dispatch(diagnoseDisease());
    } else if (activeState === 1) {
      if (result[0]) {
        dispatch(setActiveState(activeState + 1));
      } else {
        toast.error('Please select a symptom from the list');
      }
    } else {
      dispatch(setActiveState(activeState + 1));
    }
    // dispatch(setActiveState(activeState + 1));
    // setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    dispatch(setActiveState(activeState - 1));
    // setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    dispatch(setActiveState(0));
    dispatch(resetState());
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      classes={{ paper: classes.paper }}
    >
      <div className={classes.root}>
        <Stepper
          alternativeLabel
          activeStep={activeState}
          connector={<ColorlibConnector />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          {/* eslint-disable-next-line no-nested-ternary */}
          {activeState === 0 ? (
            <StepOne />
          ) : activeState === 1 ? (
            <StepTwo />
          ) : (
            <Result />
          )}
        </div>
        <div style={{ textAlign: 'right', marginTop: 30 }}>
          {activeState === steps.length ? (
            <div>
              {/* <Typography className={classes.instructions}>
                All steps completed - you&apos;re finished
              </Typography> */}
              <Button onClick={handleReset} className={classes.button}>
                Reset
              </Button>
            </div>
          ) : (
            <div>
              {/* <Typography className={classes.instructions}>
                {getStepContent(activeStep)}
              </Typography> */}
              <div>
                {/* <Button
                  disabled={activeState === 0}
                  onClick={handleBack}
                  className={classes.backbutton}
                >
                  Back
                </Button> */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  className={classes.button}
                >
                  {activeState === steps.length - 1 ? 'Finish' : 'Next'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default DiagnoiseWizard;
